import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const Dashboard = ({ size, colorCustom }: PropsAdronIcon) => {
  const theme: Theme = useTheme();

  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : "0 0 32 32"}
      style={size ? { width: size, height: size } : { width: 32, height: 32 }}
    >
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.9049 21.1867C28.0566 23.1927 26.7299 24.9604 25.0407 26.3351C23.3515 27.7099 21.3512 28.65 19.2148 29.0731C17.0784 29.4963 14.8708 29.3896 12.7851 28.7625C10.6994 28.1353 8.79905 27.0068 7.25025 25.4756C5.70144 23.9444 4.55131 22.0571 3.9004 19.9787C3.24949 17.9003 3.11764 15.6941 3.51635 13.5529C3.91507 11.4118 4.83221 9.40092 6.18761 7.69612C7.54301 5.99132 9.2954 4.6445 11.2916 3.77341M29.9582 16.0001C29.9582 14.2491 29.6133 12.5153 28.9433 10.8976C28.2732 9.27996 27.2911 7.81011 26.053 6.57199C24.8149 5.33388 23.345 4.35175 21.7273 3.68169C20.1097 3.01162 18.3758 2.66675 16.6249 2.66675V16.0001H29.9582Z"
          stroke={colorCustom ? colorCustom : theme.palette.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Dashboard;
